import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../actions/globalAction';
import { getOptions } from '../components/options/ist';
import { data } from '../components/data/ist';
import { ist } from '../components/objects/ist';
import { Loader } from '../components/solar/Loader';
import { IstProgress } from '../components/solar/IstProgress';
import { IstProgressYear } from '../components/solar/IstProgressYear';
import { StatCard, StatCardSkeleton } from '../components/solar/StatCard';
import { ChartCardWithPagination } from '../components/solar/ChartCardWithPagination';
import { Bar } from 'react-chartjs-2';
import { Card } from 'react-bootstrap';


class ISTClass extends Component {
    static getDerivedStateFromProps(nextProps, prevState) {
        const nextYear = parseInt(nextProps.match.params.Year) || 0;
        if (prevState.prevYear !== nextYear) {
            return { prevYear: nextYear, _fetchNeeded: true };
        }
        return null;
    }

    componentDidMount() {
        const Year = parseInt(this.props.match.params.Year) || 0;

        this.setState({ prevYear: Year }, () => {
            var d = new Date();
            d.setMonth(d.getMonth() + 1);
            const month = d.getMonth();

            if (Year > 0) {
                ist.IstProgressClass.url = ist.IstProgressClass.defaultSegment + "/" + Year + "/" + month;
                ist.IstProgressClass.forceRefresh = true;

                ist.IstProgressYearClass.url = ist.IstProgressYearClass.defaultSegment + "/" + Year;
                ist.IstProgressYearClass.forceRefresh = true;

                ist.BarDiagrammIstClass.forceRefresh = true;
                ist.BarDiagrammIstClass.url = ist.BarDiagrammIstClass.defaultSegment + "/hBar/" + Year;
            }
            else {
                ist.IstProgressClass.url = ist.IstProgressClass.defaultSegment + "/" + new Date().getFullYear() + "/" + month;
                ist.IstProgressYearClass.url = ist.IstProgressYearClass.defaultSegment + "/" + new Date().getFullYear();
            }

            for (var k in ist) {
                this.props.request(ist[k]);
            }
        });
    }

    componentDidUpdate() {
        if (this.state._fetchNeeded) {
            const nextYear = parseInt(this.props.match.params.Year) || 0;

            var d = new Date();
            d.setMonth(d.getMonth() + 1);
            const month = d.getMonth();

            this.setState({ _fetchNeeded: false }, () => {
                ist.BarDiagrammIstClass.forceRefresh = true;
                ist.IstProgressClass.forceRefresh = true;
                ist.IstProgressYearClass.forceRefresh = true;

                if (nextYear > 0) {
                    ist.IstProgressYearClass.url = ist.IstProgressYearClass.defaultSegment + "/" + nextYear;
                    ist.IstProgressClass.url = ist.IstProgressClass.defaultSegment + "/" + nextYear + "/" + month;
                    ist.BarDiagrammIstClass.url = ist.BarDiagrammIstClass.defaultSegment + "/hBar/" + nextYear;
                }

                for (var k in ist) {
                    this.props.request(ist[k]);
                }
            });
        }
    }

    state = {};

    render() {
        const Jahr = this.props.match.params.Year ? parseInt(this.props.match.params.Year) : new Date().getFullYear();
        return (
            <div>
                <Loader show={!this.props.isLoaded} />
                <h3>Monatsertrag {Jahr}</h3>
                {renderKPIRow(this.props)}
                {renderUIGesamt(this.props)}
            </div>
        );
    }
}

/**
 * KPI-Zeile: Gesamtertrag, Ziel, Erreichungsquote, aktueller Monat
 * als StatCards über dem Chart.
 */
function renderKPIRow(props) {
    if (!props.isLoaded) {
        return (
            <div className="stat-cards-row">
                <StatCardSkeleton variant="energy" />
                <StatCardSkeleton />
                <StatCardSkeleton variant="progress" />
                <StatCardSkeleton />
            </div>
        );
    }

    const barData = props.BarDiagrammIstUI || [];
    const Jahr = props.match.params.Year ? parseInt(props.match.params.Year) : new Date().getFullYear();

    // Summiere alle Monatswerte
    let gesamtIst = 0;
    let gesamtSoll = 0;
    if (Array.isArray(barData)) {
        for (let i = 0; i < barData.length; i++) {
            gesamtIst += Number(barData[i].ist) || 0;
            gesamtSoll += Number(barData[i].soll) || 0;
        }
    }

    // Erreichungsquote aus Progress-Daten (oder berechnen)
    const quote = Number(props.IstProgressYearUI) || 0;

    // Aktueller Monat (Index vom aktuellen Kalendermonat, 0-basiert)
    const jetzt = new Date();
    const monatIndex = jetzt.getMonth();
    let aktMonatIst = 0;
    let aktMonatName = '';
    if (Array.isArray(barData) && barData[monatIndex]) {
        aktMonatIst = Number(barData[monatIndex].ist) || 0;
        aktMonatName = barData[monatIndex].monthname || `Monat ${monatIndex + 1}`;
    }

    return (
        <div className="stat-cards-row">
            <StatCard
                value={gesamtIst}
                label={'Gesamtertrag ' + Jahr}
                unit=" kWh"
                icon={<i className="bi bi-sun" />}
                variant="energy"
                subLabel={Math.round(gesamtIst).toLocaleString('de-DE') + ' kWh'}
                description="Tatsächlicher Gesamtstromertrag der PV-Anlage im gewählten Jahr. Basierend auf Wechselrichterdaten."
            />
            <StatCard
                value={gesamtSoll}
                label={'Ziel ' + Jahr}
                unit=" kWh"
                icon={<i className="bi bi-bullseye" />}
                subLabel={Math.round(gesamtSoll).toLocaleString('de-DE') + ' kWh'}
                description="PVGIS-geschätzter Soll-Wert für das Jahr. Beruht auf Wetterprognose und Anlagendimensionierung."
            />
            <StatCard
                value={quote}
                label="Erreichungsquote"
                unit=" %"
                icon={<i className="bi bi-graph-up-arrow" />}
                variant={quote >= 100 ? 'energy' : quote >= 75 ? 'progress' : 'consumption'}
                subLabel={Math.round(quote).toLocaleString('de-DE') + ' % des Ziels'}
                description="Verhältnis von Ist-Ertrag zu Soll-Wert in Prozent. Werte über 100% sind möglich (besseres Wetter als geplant)."
            />
            <StatCard
                value={aktMonatIst}
                label={aktMonatName}
                unit=" kWh"
                icon={<i className="bi bi-calendar-month" />}
                subLabel={'Stand ' + jetzt.toLocaleDateString('de-DE')}
                description={`Bisheriger Monatsertrag für ${aktMonatName}. Wird täglich aktualisiert.`}
            />
        </div>
    );
}

function renderUIGesamt(props) {
    let BarDiagrammIstUI = props.BarDiagrammIstUI || {}
    let IstProgressUI = props.IstProgressUI || {}
    let IstProgressYearUI = props.IstProgressYearUI || {}

    let hasData = BarDiagrammIstUI.length > 0 && typeof (BarDiagrammIstUI[0].monthname) !== 'undefined';

    // default chart data to avoid rendering undefined
    let chartData = { labels: [''], datasets: [{ data: [0] }, { data: [0] }, { data: [0] }] }

    if (hasData) {
        let labels = [];
        let dataist = [];
        let datasoll = [];
        let datamore = [];

        for (var k in BarDiagrammIstUI) {
            labels.push(BarDiagrammIstUI[k].monthname);
            dataist.push(BarDiagrammIstUI[k].ist);
            datasoll.push(BarDiagrammIstUI[k].soll);
            datamore.push(BarDiagrammIstUI[k].more);
        }
        chartData = {
            labels: labels,
            datasets: [
                { ...data.datasets[0], data: dataist },
                { ...data.datasets[1], data: datasoll },
                { ...data.datasets[2], data: datamore }
            ]
        };
    }

    return (
        <ChartCardWithPagination
            loading={!props.isLoaded || !hasData}
            routeSegment={'ist'}
            onlyYear={true}
            match={props.match}
            history={props.history}>
            <Card className="chart-card">
                <Card.Body>
                    <div>Fortschritt aktuelles Monat: <IstProgress value={IstProgressUI} /></div>
                    <div>Fortschritt Jahr {props.match.params.Year || new Date().getFullYear()}: <IstProgressYear value={IstProgressYearUI} /></div>
                    <Bar data={chartData} options={{ ...getOptions(), animation: false, indexAxis: 'y' }} />
                </Card.Body>
            </Card>
        </ChartCardWithPagination>
    );
}

export default connect(
    state => state.istReducer,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(ISTClass);